import { CustomerEligibilityV2Type, CustomerEligibilityFormV2Type } from 'src/lib/types/discountsV2'
import { CustomerEligibilityOptions, CustomerEligibilityStateType } from 'src/lib/types/common/customerConditions'
import { FileTypeOptions } from 'src/lib/types/common/files'

export const discountToGenericState = (discount: CustomerEligibilityFormV2Type): CustomerEligibilityStateType => {
  switch (discount.type) {
    case CustomerEligibilityV2Type.ALL_CUSTOMERS:
      return { type: CustomerEligibilityOptions.ALL_CUSTOMERS }

    case CustomerEligibilityV2Type.FIRST_TIME_CUSTOMERS:
      return { type: CustomerEligibilityOptions.FIRST_TIME_CUSTOMERS }

    case CustomerEligibilityV2Type.LIFETIME_ORDER_COUNT:
      return {
        type: CustomerEligibilityOptions.LIFETIME_ORDER_COUNT,
        minimumOrders: discount.prerequisiteUserOrderCohort.lifetimeMinOrderCount ?? '',
        maximumOrders: discount.prerequisiteUserOrderCohort.lifetimeMaxOrderCount ?? null
      }

    case CustomerEligibilityV2Type.CUSTOMER_SPECIFIC:
      return {
        type: CustomerEligibilityOptions.CUSTOMER_SEGMENT,
        segmentIds: discount.segmentIds
      }

    case CustomerEligibilityV2Type.SPECIFIC_CUSTOMERS:
      return {
        type: CustomerEligibilityOptions.SPECIFIC_CUSTOMERS,
        uploadedFile: {
          type: FileTypeOptions.CSV,
          url: discount.fileMeta.downloadUrl || '',
          name: discount.fileMeta.fileKey || '',
          size: discount.fileMeta.size || 0,
          count: 0
        }
      }

    case CustomerEligibilityV2Type.UTM_PARAMS: {
      const utmData: Record<string, string[]> = {}
      const { utmParams } = discount
      if (utmParams.source.length) utmData['utm_source'] = utmParams.source
      if (utmParams.medium.length) utmData['utm_medium'] = utmParams.medium
      if (utmParams.campaign.length) utmData['utm_campaign'] = utmParams.campaign
      if (utmParams.content.length) utmData['utm_content'] = utmParams.content
      return {
        type: CustomerEligibilityOptions.UTM_PARAMS,
        utmData
      }
    }

    default:
      return { type: CustomerEligibilityOptions.ALL_CUSTOMERS }
  }
}

export const genericToDiscountState = (generic: CustomerEligibilityStateType): CustomerEligibilityFormV2Type => {
  switch (generic.type) {
    case CustomerEligibilityOptions.ALL_CUSTOMERS:
      return { type: CustomerEligibilityV2Type.ALL_CUSTOMERS }

    case CustomerEligibilityOptions.FIRST_TIME_CUSTOMERS:
      return { type: CustomerEligibilityV2Type.FIRST_TIME_CUSTOMERS }

    case CustomerEligibilityOptions.LIFETIME_ORDER_COUNT:
      return {
        type: CustomerEligibilityV2Type.LIFETIME_ORDER_COUNT,
        prerequisiteUserOrderCohort: {
          lifetimeMinOrderCount: generic.minimumOrders,
          lifetimeMaxOrderCount: generic.maximumOrders
        }
      }

    case CustomerEligibilityOptions.CUSTOMER_SEGMENT:
      return {
        type: CustomerEligibilityV2Type.CUSTOMER_SPECIFIC,
        segmentIds: generic.segmentIds,
        overridePreEvaluatedSegment: true
      }

    case CustomerEligibilityOptions.SPECIFIC_CUSTOMERS:
      return {
        type: CustomerEligibilityV2Type.SPECIFIC_CUSTOMERS,
        customerSpecific: true,
        fileMeta: {
          fileUrl: generic.uploadedFile?.url || '',
          fileName: generic.uploadedFile?.name,
          size: generic.uploadedFile?.size || 0
        }
      }

    case CustomerEligibilityOptions.UTM_PARAMS: {
      const { utmData } = generic
      return {
        type: CustomerEligibilityV2Type.UTM_PARAMS,
        utmParams: {
          source: utmData['utm_source'] || [],
          medium: utmData['utm_medium'] || [],
          campaign: utmData['utm_campaign'] || [],
          content: utmData['utm_content'] || []
        }
      }
    }

    default:
      return { type: CustomerEligibilityV2Type.ALL_CUSTOMERS }
  }
}

export const DISCOUNT_ALLOWED_ELIGIBILITY_OPTIONS: CustomerEligibilityOptions[] = [
  CustomerEligibilityOptions.ALL_CUSTOMERS,
  CustomerEligibilityOptions.FIRST_TIME_CUSTOMERS,
  CustomerEligibilityOptions.LIFETIME_ORDER_COUNT,
  CustomerEligibilityOptions.SPECIFIC_CUSTOMERS,
  CustomerEligibilityOptions.CUSTOMER_SEGMENT,
  CustomerEligibilityOptions.UTM_PARAMS
]
